export default __webpack_public_path__ + "static/media/logo-ep.561f9433.svg";